import * as BasicSpacing from './BasicSpacing';

export const SPACING_NONE = BasicSpacing.SPACING_000;

export const SPACING_LEAST = BasicSpacing.SPACING_001;

export const SPACING_XXS = BasicSpacing.SPACING_004;

export const SPACING_XS = BasicSpacing.SPACING_008;

export const SPACING_S = BasicSpacing.SPACING_012;

export const SPACING_M = BasicSpacing.SPACING_016;

export const SPACING_L = BasicSpacing.SPACING_020;

export const SPACING_XL = BasicSpacing.SPACING_024;

export const SPACING_2XL = BasicSpacing.SPACING_028;

export const SPACING_3XL = BasicSpacing.SPACING_032;

export const SPACING_4XL = BasicSpacing.SPACING_036;

export const SPACING_5XL = BasicSpacing.SPACING_040;

export const SPACING_6XL = BasicSpacing.SPACING_048;

export const SPACING_7XL = BasicSpacing.SPACING_056;

export const SPACING_MAX = BasicSpacing.SPACING_064;

// eslint-disable-next-line prefer-destructuring
export const SPACING_AUTO = BasicSpacing.SPACING_AUTO;

const GenericSpacing = {
    SPACING_NONE,
    SPACING_LEAST,
    SPACING_XXS,
    SPACING_XS,
    SPACING_S,
    SPACING_M,
    SPACING_L,
    SPACING_XL,
    SPACING_2XL,
    SPACING_3XL,
    SPACING_4XL,
    SPACING_5XL,
    SPACING_6XL,
    SPACING_7XL,
    SPACING_MAX,
    SPACING_AUTO,
};

export default GenericSpacing;
